export const UserSymbol = Symbol('user');
